module.exports = __webpack_public_path__ + "static/img/banner1.517dc98.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/banner1.png
// module id = Hs6o
// module chunks = 1